import { matchRouteName } from '@helpers/page-state';
import axios from 'axios';

const state = (matchRouteName('ad-details') || matchRouteName('adverts.posted-by') || matchRouteName('chat')) && {
    primaryPhoneNumberE164: null,
    secondaryPhoneNumberE164: null,
};

const actions = {
    getPhoneNumber({ commit }, params) {
        const { userUuid, isPrimaryPhoneNumber, adUuid } = params;
        return axios.get(`/api/user/${userUuid}/phone`, { params: { adUuid } })
            .then(({ data }) => {
                if (isPrimaryPhoneNumber) {
                    commit('setPrimaryPhoneNumber', data);
                } else {
                    commit('setSecondaryPhoneNumber', data);
                }
            });
    },
    callPhoneNumber({ commit }, params) {
        const { userUuid, adUuid } = params;
        return axios.post(`/api/user/${userUuid}/phone-call`, { adUuid });
    },
};

const mutations = {
    setPrimaryPhoneNumber(state, payload) {
        const { phone_number_e164 } = payload;
        state.primaryPhoneNumberE164 = phone_number_e164;
    },
    setSecondaryPhoneNumber(state, payload) {
        const { phone_number_e164 } = payload;
        state.secondaryPhoneNumberE164 = phone_number_e164;
    },
};

const getters = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
